import { IUser } from 'src/models/interfaces/user';
import apiService from './api';
import tokenService from './token';

export class AuthService {
  public user?: IUser | null;

  private updateUserCallBack: ((user: IUser) => void) | null = null;

  public async login(email: string, registration: string): Promise<void> {
    return apiService.post('/auth/login', { email, registration })
      .then(({ data }: any) => {
        tokenService.setToken(data);
        this.fillUser(data);
        if (this.user && this.updateUserCallBack)
          this.updateUserCallBack(this.user);
      });
  }

  public updateUser(cb: (user: IUser) => void) {
    this.updateUserCallBack = cb;
  }

  public logout() {
    this.user = null;
    tokenService.clearToken();
  }

  public loadUser() {
    const token = tokenService.getToken();
    if (!token) return null;

    const user = tokenService.decode<IUser>(token);
    if (!user) return null;

    user.fullName = `${user.firstName} ${user.lastName}`;
    user.roles = user.roles || [];

    this.user = user;

    if (this.updateUserCallBack)
      this.updateUserCallBack(this.user);

    return this.user;
  }

  private fillUser(token: string) {
    const user = tokenService.decode<IUser>(token);

    if (!user) return null;

    user.fullName = `${user.firstName} ${user.lastName}`;
    user.roles = user.roles || '';

    this.user = user;
  }

  public canAccess(...roles: string[]) {
    if (!this.user) return false;

    if (!roles || roles.length === 0) return true;
    if (this.user.roles.includes('sysAdmin')) return true;

    return roles.some(r => this.user?.roles.includes(r));
  }

  public isAuthenticated() {
    return !!this.user;
  }
}

const authService = new AuthService();
export default authService;
